import { onMount } from 'svelte';

export const DynamicStylesTagId = 'dynamic-css';

export function toDynamicStylesTag(dynamicCss: string) {
  return dynamicCss ? `<style id="${DynamicStylesTagId}">${dynamicCss}</style>` : null;
}

export function onMountMoveDynamicStyles(): void {
  onMount(() => {
    const dynamicStyles = document.getElementById(DynamicStylesTagId);
    if (dynamicStyles) {
      document.head.appendChild(dynamicStyles);
    }
  });
}
